import {isMobile} from "../../website/webpack/modules/devices";

$(document).ready(function () {
    $('#sticky-bar').stickySidebar({
        topSpacing: isMobile() ? 87 : $('#headCnt').height() - 50,
        innerWrapperSelector: '.sticky-bar__inner'
    });

    $('.goto-anchor').click(function (event) {
        event.preventDefault();
        let anchor = $(this).attr('href')||'';
        gotoAnchor(anchor);
    });
});

function gotoAnchor(anchor) {
    anchor = anchor.replace('#', '');
    let negativeOffset = $('#sticky-bar').offset().top + $('#sticky-bar .sticky-bar__inner').height() + 30;
    let topOffset = document.getElementById(anchor).offsetTop - negativeOffset;
    window.scroll(
        {
            top: topOffset,
            behavior: 'smooth'
        }
    );
}